import { fetchLang } from "@util/http";
import { codeToLocale } from "@util/langConfig";

const DEFAULT_TEAM_VIP_SOURCE = "OFFICIAL_SITE_ACTIVE";

function validateTeamId(teamId) {
  if (teamId === undefined || teamId === null || teamId === "") {
    throw new Error("teamId不能为空");
  }
}

function getSessionStorageItem(key) {
  if (typeof sessionStorage === "undefined") return null;
  return sessionStorage.getItem(key);
}

function resolveJoinParams({ teamId, source, creatorId } = {}) {
  validateTeamId(teamId);

  const storedTargetTeamId = getSessionStorageItem("targetTeamId");
  const allowLegacySessionFallback = !storedTargetTeamId;
  const storedInviterId = allowLegacySessionFallback
    ? getSessionStorageItem("inviterId")
    : null;
  const storedInviteSource = allowLegacySessionFallback
    ? getSessionStorageItem("inviteSource")
    : null;
  const rawCreatorId = creatorId ?? storedInviterId;
  const numericCreatorId = Number(rawCreatorId);
  const resolvedCreatorId =
    rawCreatorId !== undefined &&
    rawCreatorId !== null &&
    rawCreatorId !== "" &&
    Number.isSafeInteger(numericCreatorId) &&
    numericCreatorId > 0
      ? numericCreatorId
      : undefined;

  return {
    teamId: String(teamId),
    source: source || storedInviteSource || DEFAULT_TEAM_VIP_SOURCE,
    ...(resolvedCreatorId !== undefined && resolvedCreatorId !== null
      ? { creatorId: resolvedCreatorId }
      : {}),
  };
}

function resolveAcceptLanguage(language) {
  const languageText = String(language || "");
  if (!languageText) return undefined;
  if (languageText.includes(",")) return languageText;
  return codeToLocale(languageText.split("-")[0]);
}

export function queryTeamVipOpenStatus(teamId, language) {
  try {
    validateTeamId(teamId);
  } catch (error) {
    return Promise.reject(error);
  }

  const query = new URLSearchParams({ teamId: String(teamId) }).toString();
  const acceptLanguage = resolveAcceptLanguage(language);
  return fetchLang(`/api/teamVip/openStatus?${query}`, {
    method: "GET",
  }, acceptLanguage).then((response) => response.json());
}

export function queryTeamVipIsMember(teamId) {
  try {
    validateTeamId(teamId);
  } catch (error) {
    return Promise.reject(error);
  }

  const query = new URLSearchParams({ teamId: String(teamId) }).toString();
  return fetchLang(`/api/teamVip/isMember?${query}`, {
    method: "GET",
  }).then((response) => response.json());
}

export function joinTeamVip(params) {
  let requestParams;

  try {
    requestParams = resolveJoinParams(params);
  } catch (error) {
    return Promise.reject(error);
  }

  // TODO: 接口联调完成后移除 mock 分支，保留下方正式请求。
  // if (USE_TEAM_VIP_API_MOCK) {
  //   TEAM_VIP_MEMBER_SOURCE_MOCK.set(
  //     getMockMemberKey(requestParams.teamId),
  //     requestParams.source
  //   );
  //   return Promise.resolve({
  //     success: true,
  //     error: null,
  //     info: null,
  //     result: {
  //       joined: true,
  //       sourceType: requestParams.source,
  //     },
  //   });
  // }

  return fetchLang("/api/teamVip/join", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(requestParams),
  }).then((response) => response.json());
}
